import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React, { useEffect, useState, useCallback } from "react";
import SearchResult from "./search/search-result";
import LoadingSpinner from "./common/loading-spinner";
import { globalHistory } from "@reach/router";
import { useGooglePSE } from "../services/googlePSE";
var SearchResultPreview = function SearchResultPreview(_ref) {
    var _hit$pagemap, _hit$pagemap$metatags, _hit$pagemap$metatags2;
    var hit = _ref.hit;
    var result = {
        slug: hit.link,
        title: hit.htmlTitle || hit.title,
        text: hit.snippet,
        body: hit.htmlSnippet || hit.snippet,
        authors: [],
        // Google PSE doesn't provide authors, could be extracted from metadata
        pubDate: ((_hit$pagemap = hit.pagemap) === null || _hit$pagemap === void 0 ? void 0 : (_hit$pagemap$metatags = _hit$pagemap.metatags) === null || _hit$pagemap$metatags === void 0 ? void 0 : (_hit$pagemap$metatags2 = _hit$pagemap$metatags[0]) === null || _hit$pagemap$metatags2 === void 0 ? void 0 : _hit$pagemap$metatags2["article:published_time"]) || ""
    };
    return /*#__PURE__*/ React.createElement(SearchResult, {
        result: result
    });
};
var InfiniteHits = function InfiniteHits(_ref2) {
    var hits = _ref2.hits, loadNextPage = _ref2.loadNextPage, hasMore = _ref2.hasMore, totalResults = _ref2.totalResults;
    return /*#__PURE__*/ React.createElement("div", null, hits.map(function (hit, index) {
        return /*#__PURE__*/ React.createElement(SearchResultPreview, {
            hit: hit,
            key: hit.link + index
        });
    }), hasMore && /*#__PURE__*/ React.createElement("button", {
        className: "bg-gray-400 px-3 py-2 hover:text-white hover:bg-makroOrange",
        onClick: loadNextPage
    }, "weitere Ergebnisse laden"), totalResults && /*#__PURE__*/ React.createElement("p", {
        className: "text-right md:-mt-8"
    }, "Anzahl Ergebnisse: ", totalResults));
};
var Search = function Search(_ref3) {
    var visible = _ref3.visible, setVisibility = _ref3.setVisibility;
    var _useState = useState(""), searchText = _useState[0], setSearchText = _useState[1];
    var _useState2 = useState(1), currentPage = _useState2[0], setCurrentPage = _useState2[1];
    var _useState3 = useState([]), allResults = _useState3[0], setAllResults = _useState3[1];
    var _useState4 = useState(0), totalResults = _useState4[0], setTotalResults = _useState4[1];
    var pageSize = 10;
    var _useGooglePSE = useGooglePSE(), data = _useGooglePSE.data, loading = _useGooglePSE.loading, error = _useGooglePSE.error, search = _useGooglePSE.search, searchPaginated = _useGooglePSE.searchPaginated;
    useEffect(function () {
        if (data) {
            var newResults = data.items || [];
            var totalCount = parseInt(data.searchInformation.totalResults);
            if (currentPage === 1) {
                setAllResults(newResults);
            }
            else {
                setAllResults(function (prev) {
                    return [].concat(_toConsumableArray(prev), _toConsumableArray(newResults));
                });
            }
            setTotalResults(totalCount);
        }
    }, [data, currentPage]);
    var doSearch = useCallback(/*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(val) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(val && val.length >= 2)) {
                                _context.next = 5;
                                break;
                            }
                            setCurrentPage(1);
                            setAllResults([]);
                            _context.next = 5;
                            return search({
                                query: val,
                                siteSearch: "makroskop.eu",
                                num: pageSize
                            });
                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee);
        }));
        return function (_x) {
            return _ref4.apply(this, arguments);
        };
    }(), [search, pageSize]);
    useEffect(function () {
        var handleLocationChange = function handleLocationChange(_ref5) {
            var action = _ref5.action, location = _ref5.location;
            if (["POP", "PUSH"].includes(action) && location.search.includes("search=")) {
                var _location$search;
                var text = (_location$search = location.search) === null || _location$search === void 0 ? void 0 : _location$search.split("=")[1];
                var decodedText = decodeURI(text);
                setSearchText(decodedText);
                doSearch(decodedText);
            }
        };
        var unsubscribe = globalHistory.listen(handleLocationChange);
        if (window.location.search.includes("search=")) {
            var _window$location$sear;
            var text = (_window$location$sear = window.location.search) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear.split("=")[1];
            var decodedText = decodeURI(text);
            setSearchText(decodedText);
            doSearch(decodedText);
        }
        return unsubscribe;
    }, [doSearch]);
    useEffect(function () {
        if (!visible) {
            window.history.pushState(null, document.title, window.location.pathname);
        }
        else if (visible && window.location.search.includes("search=")) {
            var _window$location$sear2;
            var text = (_window$location$sear2 = window.location.search) === null || _window$location$sear2 === void 0 ? void 0 : _window$location$sear2.split("=")[1];
            var decodedText = decodeURI(text);
            setSearchText(decodedText);
            doSearch(decodedText);
        }
    }, [visible, doSearch]);
    var loadNextPage = useCallback(/*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() {
        var nextPage;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        if (!(!loading && searchText && allResults.length < totalResults)) {
                            _context2.next = 5;
                            break;
                        }
                        nextPage = currentPage + 1;
                        setCurrentPage(nextPage);
                        _context2.next = 5;
                        return searchPaginated({
                            query: searchText,
                            siteSearch: "makroskop.eu",
                            num: pageSize
                        }, nextPage, pageSize);
                    case 5:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2);
    })), [loading, searchText, allResults.length, totalResults, currentPage, searchPaginated, pageSize]);
    var handleInputChange = function handleInputChange(e) {
        setSearchText(e.target.value);
    };
    var handleSearch = function handleSearch() {
        if (searchText.trim()) {
            window.history.pushState(null, document.title, window.location.pathname + "?search=" + encodeURI(searchText));
            doSearch(searchText);
        }
    };
    var handleKeyPress = function handleKeyPress(e) {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };
    var hasMore = allResults.length < totalResults && totalResults > 0;
    return /*#__PURE__*/ React.createElement("div", {
        className: "border-solid border-t-8 border-makroOrange bg-white inset-0 z-50" + (visible ? "" : " hidden")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-between pt-1 items-start"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "flex w-full text-xl text-makroOrange uppercase"
    }, "SUCHE"), /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return setVisibility(!visible);
        },
        className: "pb-2"
    }, "schlie\xDFen")), /*#__PURE__*/ React.createElement("div", {
        className: "container mx-auto px-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "px-8 py-16 relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "search",
        value: searchText,
        onChange: handleInputChange,
        onKeyPress: handleKeyPress,
        placeholder: "Suchbegriff eingeben",
        className: "text-3xl text-black py-2 border-b border-solid border-black w-full"
    }), /*#__PURE__*/ React.createElement("button", {
        className: "inline-block mt-8 mb-2 px-16 py-1 text-white border-2 border-solid border-makroOrange bg-makroOrange",
        onClick: handleSearch
    }, "LOS")), loading && /*#__PURE__*/ React.createElement(LoadingSpinner, null), error && /*#__PURE__*/ React.createElement("div", {
        className: "text-red-600 mb-4"
    }, "Fehler bei der Suche: ", error.message), allResults.length > 0 && /*#__PURE__*/ React.createElement(InfiniteHits, {
        hits: allResults,
        loadNextPage: loadNextPage,
        hasMore: hasMore,
        totalResults: totalResults
    }), !loading && searchText && allResults.length === 0 && !error && /*#__PURE__*/ React.createElement("div", {
        className: "text-gray-600"
    }, "Keine Ergebnisse f\xFCr \"", searchText, "\" gefunden."))));
};
export default Search;
